import React, { useEffect, useState, useRef } from 'react';
import api from '../api';

interface AuthImgProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  apiPath: string;
}

export const AuthImg: React.FC<AuthImgProps> = ({ apiPath, ...rest }) => {
  const [src, setSrc] = useState<string | null>(null);
  const urlRef = useRef<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    api.get(apiPath, { responseType: 'blob' }).then(res => {
      if (cancelled) return;
      const url = URL.createObjectURL(res.data);
      urlRef.current = url;
      setSrc(url);
    }).catch(() => {});
    return () => {
      cancelled = true;
      if (urlRef.current) URL.revokeObjectURL(urlRef.current);
    };
  }, [apiPath]);

  return src ? <img src={src} {...rest} /> : null;
};

export async function openAuthedFile(apiPath: string): Promise<void> {
  const res = await api.get(apiPath, { responseType: 'blob' });
  const url = URL.createObjectURL(res.data);
  window.open(url, '_blank');
  setTimeout(() => URL.revokeObjectURL(url), 10000);
}
